import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AdminLogin from './pages/AdminLogin';
import Moderation from './pages/Moderation';
import ActivityReview from './pages/ActivityReview';
import ActivityMap from './pages/ActivityMap';
import LocationActivities from './pages/LocationActivities';
import UserManagement from './pages/UserManagement';
import Quellen from './pages/Quellen';
import AdminNav from './components/Admin/AdminNav';
import { useAuth } from './hooks/useAuth';

const AdminLayout = ({ children, requireAdmin = false }) => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: '2rem' }}>Laedt</div>;
  if (!user) return <Navigate to='/anmelden' replace />;
  if (user.role !== 'moderator' && user.role !== 'admin') return <Navigate to='/anmelden' replace />;
  if (requireAdmin && user.role !== 'admin') return <Navigate to='/moderation' replace />;
  return (
    <>
      <AdminNav />
      <main style={{ padding: '1.5rem' }}>{children}</main>
    </>
  );
};

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <Routes>
          <Route path='/anmelden' element={<AdminLogin />} />
          <Route path='/moderation' element={<AdminLayout><Moderation /></AdminLayout>} />
          <Route path='/aktivitaeten-pruefen' element={<AdminLayout><ActivityReview /></AdminLayout>} />
          <Route path='/benutzerverwaltung' element={<AdminLayout requireAdmin><UserManagement /></AdminLayout>} />
          <Route path='/aktivitaeten-karte' element={<AdminLayout><ActivityMap /></AdminLayout>} />
          <Route path='/aktivitaeten-nach-ort' element={<AdminLayout><LocationActivities /></AdminLayout>} />
          <Route path='/quellen' element={<AdminLayout><Quellen /></AdminLayout>} />
          <Route path='*' element={<Navigate to='/moderation' replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
